/** Idle timeout · session expires after 30 minutes without activity. */
export const SESSION_IDLE_MS = 30 * 60 * 1000;

/** Absolute timeout · re-authentication required after 24 hours regardless of activity. */
export const SESSION_ABSOLUTE_MS = 24 * 60 * 60 * 1000;

/** Cookie Max-Age / session store expiry (matches absolute timeout). */
export const SESSION_COOKIE_MAX_AGE_SEC = Math.floor(SESSION_ABSOLUTE_MS / 1000);

/** CSRF double-submit cookie (readable by JS, not HttpOnly). */
export const CSRF_COOKIE_NAME = "app_csrf_token";

/** Header clients must send on cookie-authenticated mutations. */
export const CSRF_HEADER_NAME = "x-csrf-token";

/** Minimum interval between `lastActivityAt` DB writes per session. */
export const SESSION_TOUCH_THROTTLE_MS = 60 * 1000;

/** Opaque session tokens are 32 random bytes encoded as hex (64 chars). */
export const OPAQUE_SESSION_TOKEN_BYTES = 32;
